import React, { useState } from 'react'

// Shows an email's HTML in a sandboxed frame: no scripts or forms run, links open in a new tab.
// allow-same-origin only lets us read the content height; without allow-scripts it can't act.
// `light` gives mail written for white backgrounds (most received mail) a white page.
const EmailFrame = ({ html, text, light = false }) => {
  const [height, setHeight] = useState(240)

  if (!html) return <pre className="adm-email-text">{text || '(This email has no content)'}</pre>

  const doc = `<!doctype html><html><head><meta charset="utf-8">
<meta http-equiv="Content-Security-Policy" content="default-src 'none'; img-src https: data:; style-src 'unsafe-inline' https:; font-src https: data:">
<base target="_blank">
<style>html,body{margin:0;}${light ? 'body{background:#fff;color:#111;font-family:Arial,sans-serif;padding:16px;}' : ''}</style>
</head><body>${html}</body></html>`

  const fit = (event) => {
    const page = event.target.contentDocument?.documentElement
    if (page) setHeight(Math.max(160, page.scrollHeight))
  }

  return (
    <iframe
      className={`adm-email-frame ${light ? 'light' : ''}`}
      title="Email content"
      sandbox="allow-same-origin allow-popups allow-popups-to-escape-sandbox"
      srcDoc={doc}
      style={{ height }}
      onLoad={fit}
    />
  )
}

export default EmailFrame
